import AddPricebook from "./AddPricebook";

export default AddPricebook;



// WEBPACK FOOTER //
// ./src/components/Pricebook/AddPricebook/index.js